import React from 'react';
import { CustomColumn } from '../../../../types/components/tables/tableTypes';
import { Status } from '../../../../types/redux/data/dataTypes';
import { percentageToTwoDecimalPlaces } from '../../../../utilities/numberFormatters';
import RaptorStatusBox from '../../../feedback/RaptorStatusBox.component';
import { specifyStatus } from '../../../../utilities/generalMappings';
import type { CssfRiskSpreadingPayload } from '../../../../api/rs-hg/risk/cssfRiskSpreading.types';

export interface CssfTableData {
  number: number;
  ruleTitle: string;
  value: number;
  limit: number;
  status: Status;
}

export const generateCssfColumns = (): CustomColumn<CssfTableData>[] => [
  {
    field: 'number',
    title: '#',
    headerStyle: {
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
    },
    width: '1%',
  },
  {
    field: 'ruleTitle',
    title: 'Rule',
    headerStyle: {
      textAlign: 'left',
    },
    cellStyle: {
      textAlign: 'left',
    },
  },
  {
    field: 'value',
    title: 'Value',
    headerStyle: {
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
    },
    width: '9.38rem',
    render: (rowData) => percentageToTwoDecimalPlaces(rowData.value),
  },
  {
    field: 'limit',
    title: 'Limit',
    headerStyle: {
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
    },
    render: (rowData) => percentageToTwoDecimalPlaces(rowData.limit),
    width: '9.38rem',
  },
  {
    field: 'status',
    title: 'Status',
    pdfRenderType: 'PageLinkButton',
    headerStyle: {
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
    },
    width: '9.38rem',
    render: (rowData: CssfTableData) => (
      <RaptorStatusBox status={specifyStatus(rowData.status)} />
    ),
  },
];

export const generateCssfData = (
  payload: CssfRiskSpreadingPayload | null | undefined,
): CssfTableData[] => {
  if (!payload?.cssf_list?.length) return [];

  // don't include the header
  return payload.cssf_list.slice(1).map((el, index) => {
    const [ruleTitle, status, value, limit] = el;
    return {
      number: index + 1,
      ruleTitle: String(ruleTitle),
      value: Number(value),
      limit: Number(limit),
      status: specifyStatus(String(status)),
    };
  });
};
